import React, { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, getEmail, setSession, clearSession } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [email, setEmail] = useState(getEmail());
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setEmail(r.data.email))
      .catch(() => {
        clearSession();
        setEmail(null);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (mail, password) => {
    const r = await api.post("/auth/login", { email: mail, password });
    setSession(r.data.token, r.data.email);
    setEmail(r.data.email);
    return r.data;
  };

  const logout = () => {
    clearSession();
    setEmail(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ email, login, logout, ready }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
